import { render } from "./ListSmsConfigs.vue?vue&type=template&id=063d3c05"
import script from "./ListSmsConfigs.vue?vue&type=script&lang=js"
export * from "./ListSmsConfigs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__